module.exports = __webpack_public_path__ + "img/katarina_kitchen_9.938e28e4.jpg";